// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-fd3bfc96]{height:4rem;margin-bottom:.75rem;margin-top:.75rem}@media screen and (min-width:768px){.search-wrapper[data-v-fd3bfc96]{margin-bottom:8.333rem}}.search-icon-wrapper[data-v-fd3bfc96]{color:#212528;font-size:1.75rem}.title[data-v-fd3bfc96]{font-size:1.2rem;margin-bottom:.3333rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
